// A check mark, for "this has been done" states — the spaces list's "Data sent"
// cell. Inline SVG like every other icon here; colour comes from the parent's
// `color`, so the cell decides it is green, not the icon.
export default function CheckIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M3 8.5l3.2 3.2L13 4.8" />
    </svg>
  )
}
